module.exports = __webpack_public_path__ + "img/scope-iot.088ba0fb.png";